import type {
  BufferAttribute,
  InterleavedBufferAttribute,
  TypedArray,
  Vector2,
  Vector3,
} from '@seddi/three';

class BufferAttributeAccessor {
  protected readonly attr: BufferAttribute | InterleavedBufferAttribute;
  protected readonly array: TypedArray;
  protected readonly itemSize: number;
  protected readonly offset: number;
  protected readonly stride: number;

  constructor(attr: BufferAttribute | InterleavedBufferAttribute) {
    this.attr = attr;
    this.array = attr.array as TypedArray;
    this.itemSize = attr.itemSize;

    if ((attr as InterleavedBufferAttribute).isInterleavedBufferAttribute) {
      this.offset = (attr as InterleavedBufferAttribute).offset;
      this.stride = (attr as InterleavedBufferAttribute).data.stride;
    } else {
      this.offset = 0;
      this.stride = attr.itemSize;
    }
  }

  get count() {
    return this.attr.count;
  }
}

export class BufferAttributeAccessor2 extends BufferAttributeAccessor {
  at(i: number, target: Vector2): Vector2 {
    const o = i * this.stride + this.offset;
    target.x = this.array[o];
    target.y = this.array[o + 1];
    return target;
  }
}

export class BufferAttributeAccessor3 extends BufferAttributeAccessor {
  at(i: number, target: Vector3): Vector3 {
    const o = i * this.stride + this.offset;
    target.x = this.array[o];
    target.y = this.array[o + 1];
    target.z = this.array[o + 2];
    return target;
  }
}
